import { $http } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    list: [],
    links: {},
    meta: {},
    form: {
      id: null,
      image: null,
      name: null,
      phone: null,
      email: null,
      is_verified: null,
      password: null,
    },
  },
  mutations: {
    SET_USER: (state, data) => Object.assign(state.form, data),
    STORE_USER: (state, data) => state.list.unshift(data),
    SET_USERS: (state, data) => {
      state.list = data.data;
      state.links = data.links;
      state.meta = data.meta;
    },
    UPDATE_USER: (state, data) => {
      state.list = state.list.filter((item) => item.id !== data.id);
      state.list.unshift(data);
    },
    DELETE_USER: (state, data) => {
      const item = state.list.find((item) => item.id === data);
      state.list.splice(state.list.indexOf(item), 1);
    },
  },
  getters: {
    user: (state) => {
      let user = new FormData();
      user.append("name", state.form.name);
      user.append("phone", state.form.phone);
      user.append("email", state.form.email);
      if (state.form.password) user.append("password", state.form.password);
      user.append("image", state.form.image);
      return user;
    },
  },
  actions: {
    async get({ commit }, { page, phone, name }) {
      const { payload } = await $http.get(
        `admin/admins?page=${page}${phone ? `&phone=${phone}` : ""}${
          name ? `&name=${name}` : ""
        }`
      );
      commit("SET_USERS", payload);
    },
    async show({ commit }, id) {
      const { payload } = await $http.get(`admin/admins/${id}`);
      commit("SET_USER", payload);
    },
    async store({ getters }) {
      return await $http.post("admin/admins", getters.user);
    },
    async update({ state, getters }) {
      return await $http.post(`admin/admins/${state.form.id}`, getters.user);
    },
    async delete(_, id) {
      return await $http.delete(`admin/admins/${id}`);
    },
  },
};
